
import { useNavigate } from "react-router-dom";
import { Pagination, Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { MensajeAlertaDanger, TooltipAndIcon } from "../../components";
import { LayoutTabla } from "../../layouts";
import { useGastosStore } from "../../../stores";
import { separadorMillares } from "../../../hooks";
import { fechaConHora } from "../../../helpers/prepararFecha";



const paginado = Number(process.env.REACT_APP_PAGINADO);



export const TablaVerGastos = ({ data, totales, chagePage, page}) => {


    const navigate = useNavigate();
    const { totalGastos } = useGastosStore();


    const handleAbonosFactura = (id, url) => {
        navigate(`/super/gasto/${url}/${id}`);
    }
    


    return (
        <>
        {(data?.length > 0)
        ?   <>
            {(totales) &&
            <LayoutTabla mb={2}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width:'25%' }}>N° Gastos</TableCell>
                        <TableCell sx={{ width:'25%' }}>Total Gastos</TableCell>
                        <TableCell sx={{ width:'25%' }}>Total Abonos</TableCell>
                        <TableCell sx={{ width:'25%' }}>Saldo Total</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    <TableRow >
                        <TableCell>{`${ separadorMillares(totales.numeroGastos)}`}</TableCell>
                        <TableCell>{`$${ separadorMillares(totales.totalGastos)}`}</TableCell>
                        <TableCell>{ `$${ separadorMillares(totales.totalGastos - totales.totalSaldo)}` }</TableCell>
                        <TableCell>{`$${ separadorMillares(totales.totalSaldo)}`}</TableCell>
                    </TableRow>
                </TableBody>
            </LayoutTabla>
            }

            <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalGastos / +paginado)} disabled={Math.ceil(totalGastos / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'20%'}}>Fecha</TableCell>
                        <TableCell sx={{width:'15%'}}>Factura</TableCell>
                        <TableCell sx={{width:'20%'}}>Proveedor</TableCell>
                        <TableCell sx={{width:'15%'}}>Compra</TableCell>
                        <TableCell sx={{width:'15%'}}>Total</TableCell>
                        <TableCell sx={{width:'15%'}}>Acciones</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                {data.map((a) => (
                    <TableRow  key={ a._id}>
                        <TableCell>{ fechaConHora(a?.createdAt) }</TableCell>
                        <TableCell>{ a.factura }</TableCell>
                        <TableCell sx={{ color: a.proveedor ? "inherit" : "error.main", fontWeight:a.proveedor ? 600 : 800 }}>
                            {a.proveedor ? a.proveedor?.nombre : "No-Dato"}
                        </TableCell>
                        <TableCell sx={{ color:a.tipo ? "inherit" : "error.main", fontWeight:a.tipo ? 600 : 800 }}>
                            {a.tipo ? a.tipo : "No-Dato"}
                        </TableCell>
                        <TableCell>{ `$${separadorMillares(a.total)}` }</TableCell>
                        <TableCell>
                            <Stack direction="row" spacing={1} justifyContent="center">
                                {/* <TooltipAndIcon
                                    titulo="Detalles de gasto"
                                    icono="ver"
                                    color="white"
                                    onClick={ () => handleVerFactura(a._id, 'ver')}
                                />   */}

                                <TooltipAndIcon
                                    titulo="Abonos de gasto"
                                    icono="abono"
                                    color="white"
                                    onClick={ () => handleAbonosFactura(a._id, 'abonos')}
                                />  
                            </Stack>
                        </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </LayoutTabla>
            </>   

        :   <MensajeAlertaDanger titulo='No hay gastos disponibles' />
        }
        </>

    )
}
